import { COMMISSIONSTATS__MUTATIONS } from "../mutation-types";
import { COMMISSIONSTATS__ACTIONS } from "../action-types";
import { COMMISSIONSTATS__API } from "@/_helpers/urls";
import http from "@/_helpers/http";

// State
const state = {
  stats: [],
  levelwisecommissionearnings: [],
  earningDetails: null,
  isLoading: false,
};

// Mutations
const mutations = {
  [COMMISSIONSTATS__MUTATIONS.COMMISSIONSTATS](state, data) {
    state.stats = data;
  },

  [COMMISSIONSTATS__MUTATIONS.LEVELWISECOMMISSIONEARNING](state, data) {
    state.levelwisecommissionearnings = data?.result;
    state.earningDetails = data?.earningDetails;
  },

  SET_LOADING(state, loadingState) {
    state.isLoading = loadingState;
  },
};

const getters = {};

// Actions
const actions = {
  async [COMMISSIONSTATS__ACTIONS.COMMISSIONSTATS]({ commit }) {
    try {
      const { data } = await http().get(COMMISSIONSTATS__API.COMMISSIONSTATS);
      commit(COMMISSIONSTATS__MUTATIONS.COMMISSIONSTATS, data?.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  },

  async [COMMISSIONSTATS__ACTIONS.LEVELWISECOMMISSIONEARNING](
    { commit },
    parameter
  ) {
    try {
      commit("SET_LOADING", true);

      const level = parameter?.level ?? "";
      const date = parameter?.date ?? "";

      const queryParams = {
        level: level !== null ? `level=${level}` : "",
        date: date !== null ? `date=${date}` : "",
      };

      const queryString = Object.values(queryParams)
        .filter((param) => param)
        .join("&");

      const { data } = await http().get(
        COMMISSIONSTATS__API.LEVELWISECOMMISSIONEARNING + `?${queryString}`
      );
      commit(COMMISSIONSTATS__MUTATIONS.LEVELWISECOMMISSIONEARNING, data);
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
